export { default } from './GatsbyHead';
export * from './GatsbyHead';
